export const siteInfo = {
  name: '日本精品一区',
  tagline: '正品精选直达',
  description: '日本精品一区汇聚日本原装正品，涵盖美妆护肤、家居日用、零食特产等热门品类，严选品质保障，让您轻松体验日本精品一区的购物乐趣，品质值得信赖。',
  keywords: '日本精品一区,日本精品购物,日本原装正品,日本美妆直邮,日本特产精选,日本代购正品,日本品质好物',
  url: 'https://www.jp-premium-zone.com',
  logo: '',
  email: 'contact@jp-premium-zone.com',
  phone: '400-888-9999',
  address: '中国上海市静安区南京西路1688号',
  wechat: 'JpPremiumZone',
  businessHours: '周一至周日 9:00 - 21:00',
  foundingYear: '2018',
};

export const brandStory = {
  title: '品牌故事',
  paragraphs: [
    '日本精品一区成立于2018年，由一群热爱日本文化和产品的年轻人创立。我们致力于为中国消费者精选日本原装正品，让每个人都能轻松享受到日本制造的卓越品质。',
    '创业初期，我们的创始人亲自走访了日本47个都道府县，从北海道到冲绳，深入当地的工厂、作坊和店铺，建立了严格的选品标准和供应链体系。每一件商品都经过团队的亲自试用和评估，确保品质过关后才会上架推荐。',
    '五年来，我们与超过200个日本知名品牌建立了深度合作关系，涵盖美妆护肤、家居日用、零食特产、健康保健、母婴用品等多个品类。我们的选品团队每年赴日考察超过20次，不断发掘新的优质产品。',
    '我们始终秉持"品质为上、用户为先"的经营理念，不仅是商品的搬运工，更是日本品质生活的传播者。未来，我们将继续深耕日本市场，为消费者带来更多惊喜和美好体验。',
  ],
};

export const testimonials = [
  {
    id: 1,
    name: '林女士',
    location: '上海',
    rating: 5,
    content: '已经在这里买了很多次了，每次都很满意。包装很用心，产品也都是正品，发货速度也很快。特别是护肤品，用着效果很好，和我在日本买的一模一样。',
    date: '2025-07-20',
  },
  {
    id: 2,
    name: '张先生',
    location: '北京',
    rating: 5,
    content: '给老婆买的SK-II套装，她用了说和在专柜买的一样好。价格比专柜实惠不少，以后就锁定你们家了！客服也很专业耐心。',
    date: '2025-07-15',
  },
  {
    id: 3,
    name: '陈女士',
    location: '广州',
    rating: 5,
    content: '买了很多日本零食，白色恋人和Royce生巧都很好吃，包装很精致，送人也很有面子。物流也快，下单到收货只用了3天。',
    date: '2025-07-10',
  },
  {
    id: 4,
    name: '王女士',
    location: '深圳',
    rating: 5,
    content: '母婴产品一直在这买，小林退热贴和贝亲奶瓶都用着很放心。正品保障这一点让我很安心，毕竟是给宝宝用的东西。',
    date: '2025-07-05',
  },
  {
    id: 5,
    name: '李先生',
    location: '杭州',
    rating: 5,
    content: '日本保健品的选择很丰富，客服还帮我推荐了适合我体质的产品，很专业。吃了两个月感觉效果明显，会继续回购的。',
    date: '2025-06-28',
  },
  {
    id: 6,
    name: '赵女士',
    location: '成都',
    rating: 5,
    content: '朋友推荐过来的，第一次购物体验很好。买了无印良品的香薰机和几件收纳用品，品质真的没话说，日式简约风很符合我家的装修风格。',
    date: '2025-06-20',
  },
];

export const faqs = [
  {
    question: '你们的产品都是日本原装正品吗？',
    answer: '是的，我们所有产品均从日本本土正规渠道采购，每一件商品都可以追溯到日本原产地。我们与日本品牌方或一级代理商直接合作，确保100%正品保障。如有任何疑问，我们支持专柜验货。',
  },
  {
    question: '发货需要多长时间？',
    answer: '国内现货商品下单后24小时内发货，通常1-3个工作日送达。日本直邮商品需要5-10个工作日。具体配送时间会根据您的收货地址有所不同，下单时可以看到预计送达时间。',
  },
  {
    question: '支持哪些支付方式？',
    answer: '我们支持微信支付、支付宝、银行卡转账等多种支付方式，方便快捷。所有支付环节均采用安全加密技术，保障您的资金安全。',
  },
  {
    question: '如何退换货？',
    answer: '我们提供7天无理由退换货服务（不影响二次销售的前提下）。如收到商品有质量问题，请在签收后24小时内联系客服，我们将在核实后为您办理退换。食品、保健品等特殊商品拆封后不支持退换。',
  },
  {
    question: '如何辨别产品的生产日期？',
    answer: '日本商品通常使用生产批号标注，而非直接标注生产日期。如果您需要了解具体生产日期，可以联系我们的客服，我们会帮您查询对应批号的生产日期。大部分日本护肤品的保质期为未开封3年，开封后建议6-12个月内使用完毕。',
  },
];